module.exports = __webpack_public_path__ + "img/otp@2x.b3fd12ec.png";